/**
 * Metadati applicativi mostrati nel footer globale.
 *
 * `APP_VERSION` proviene da `package.json` (iniettata a build-time da Vite come
 * `__APP_VERSION__`, vedi `vite.config.ts`): unica fonte di verità, si aggiorna
 * bumpando la `version` del pacchetto.
 */
export const APP_VERSION = __APP_VERSION__;

/** URL del sito Appfactory (attribuzione nel footer). */
export const APPFACTORY_URL = 'https://appfactory.it';

/** Rotta interna della pagina Changelog (renderizza `public/CHANGELOG.md`). */
export const CHANGELOG_PATH = '/changelog';

/** File markdown del changelog, servito staticamente da `public/`. */
export const CHANGELOG_MD_URL = '/CHANGELOG.md';
